<form [formGroup]="form">
  <div class="row">
    <div class="col-md-6">
      <app-bs-display
        key="UserProfile.ParticipantNumber"
        [valueText]="form.controls.ParticipantNumber?.value"
      >
      </app-bs-display>
    </div>
    <div class="col-md-6">
      <app-bs-display
        key="UserProfile.Username"
        [valueText]="form.controls.Username?.value"
      >
      </app-bs-display>
    </div>
    <div class="col-md-6">
      <bs-ng-text
        formControlName="Email"
        identifier="Email"
        key="UserProfile.Email"
        name="Email"
      >
      </bs-ng-text>
    </div>
    <div class="col-md-6">
      <bs-ng-text
        formControlName="ConfirmEmail"
        identifier="ConfirmEmail"
        key="UserProfile.ConfirmEmail"
        name="ConfirmEmail"
      >
      </bs-ng-text>
    </div>
  </div>
</form>
